/**
 * Errors the portal branches on.
 *
 * The client throws `ApiError` from `@/lib/apiClient`, which carries a stable
 * `code`. Screens branch on that code — never on the message, which is human
 * text and may change.
 */

export type PortalErrorCode = "NOT_FOUND" | "FORBIDDEN" | "VALIDATION" | "CONFLICT" | "UNAVAILABLE";

/**
 * Server codes that name the same thing as a portal code. The API's shared
 * error factory says `VALIDATION_ERROR`; the screens only ever say `VALIDATION`.
 */
const SERVER_ALIASES: Readonly<Record<string, PortalErrorCode>> = {
  VALIDATION_ERROR: "VALIDATION",
};

/** The stable code of any error the client throws, or null. Server aliases are normalised. */
export function errorCode(error: unknown): string | null {
  if (error && typeof error === "object" && "code" in error) {
    const code = (error as { code?: unknown }).code;
    if (typeof code !== "string") return null;
    return SERVER_ALIASES[code] ?? code;
  }
  return null;
}

export function errorMessage(error: unknown, fallback: string): string {
  return error instanceof Error && error.message ? error.message : fallback;
}
